<template>
    <f7-card class="mytable">

        <f7-list v-if="search" class="search" form>
            <f7-list-item>
                <f7-input type="text" :placeholder="searchPlaceHolder" v-model="q"/>
            </f7-list-item>
        </f7-list>

        <slot>
            <f7-table style="margin-bottom:70px;">
                <f7-table-row heading>
                    <f7-table-cell>#</f7-table-cell>
                    <f7-table-cell
                            v-if="column.showInList !== false || column.title === true"
                            v-for="column in columns"
                            :key="column.name"
                            :class="column.thClass ? column.thClass : ''">
                        {{ column.label }}
                    </f7-table-cell>
                    <f7-table-cell v-if="actions && actions.length > 0"></f7-table-cell>
                </f7-table-row>

                <f7-table-row v-for="item in items" :key="item.id">
                    <f7-table-cell>{{ items.indexOf(item) + 1 }}</f7-table-cell>
                    <f7-table-cell
                            v-if="column.showInList !== false || column.title === true"
                            v-for="column in columns"
                            :key="column.name"
                            :class="(column.tdClass ? column.tdClass : '') + ' ' + (column.title === true ? 'text-right' : '')">
                        {{ getFieldValue(item, column) }}
                    </f7-table-cell>
                    <f7-table-cell v-if="actions && actions.length > 0">
                        <f7-link
                                class="button"
                                v-for="action in actions" :key="action.name"
                                @click="itemClick(item, action)"
                                v-html="action.render ? action.render(item) : (action.label ? action.label : $root.__(action.name))">
                        </f7-link>
                    </f7-table-cell>
                   <!--<f7-table-cell v-for="column in columns" :key="column.name" :class="column.tdClass"
                                   v-html="renderCell(item, column)" @click="logItem(item)">
                    </f7-table-cell>

                    <f7-table-cell v-if="actions()">
                        <f7-buttons>
                            <slot v-for="action in actions()">
                                <f7-button v-if="action.action(item)" raised fill :color="action.color ? action.color : 'blue'"
                                           :icon="(action.iconClass ? 'icon-' + action.iconClass : '')"
                                           :class="action.iconClass ? 'icon' : ''"
                                           @click="onAction(action.action(item), item)">
                                    {{ (action.label && action.label(item)) ? action.label(item) : '' }}
                                </f7-button>
                                <span v-if="!action.action(item)">
                                {{ (action.label && action.label(item)) ? action.label(item) : '' }}
                            </span>
                            </slot>
                        </f7-buttons>
                    </f7-table-cell>-->

                </f7-table-row>

            </f7-table>

            <!--<div v-if="pages.length > 1" class="pagination">
                <f7-grid>
                    <f7-col width="70" tablet-width="70">
                        <f7-link v-for="tempPage in pages"
                                 :href="$f7.mainView.url + '?page=' + tempPage" @click="changePage(tempPage)"
                                 :class="'button ' + (tempPage == page ? 'active' : '')" :key="page">
                            {{ tempPage }}
                        </f7-link>
                    </f7-col>
                    <f7-col width="30" tablet-width="30">
                        <f7-list v-if="sections.length > 0">
                            <f7-list-item>
                                <f7-input type="select" v-model="section" @change="onChange">
                                    <option v-for="item in sections" :value="item">{{ item }}</option>
                                </f7-input>
                            </f7-list-item>
                        </f7-list>
                    </f7-col>
                </f7-grid>
            </div>-->
        </slot>

        <!--<f7-block v-if="visibleItems.length === 0" inner>{{ noItemsText }}</f7-block>-->

    </f7-card>
</template>
<style>
    .mytable .list-block .item-inner {
        padding: 0;
    }
    .mytable .list-block select {
        text-align: left;
    }
</style>
<script>
    export default {
        data: function () {
            return {
                page: 0,
                total: 0,
                pages: [],
                listOrdering: 'id',
                listDirection: 'asc',
                visibleItems: [],
                q: '',
                section: '',
                filterTotal: 0
            };
        },
        computed: {
            sections: function () {
                let total = parseInt(this.filterTotal);

                let ret = [];
                let st, en;
                let limit = parseInt(this.sectionLimit);
                for (let i = 1; i <= Math.ceil(total / limit); i++) {
                    st = 1 + (i - 1) * limit;
                    en = st + limit - 1;
                    if (en > total)
                        en = total;
                    ret.push(st + ' - ' + en);
                }

                return ret;
            }
        },
        watch: {
            /*page: function (newval, oldval) {
                this.reLoad();
            },
            q: function (newval, oldval) {
                console.log('reload');
                this.page = 1;
                this.reLoad();
            },
            items: function () {
                console.log('HA');

                if (this.items.length > 0)
                    this.reLoad();
            }*/
        },
        props: {
            columns: Array,
            items: Array,
            actions: Array,
            limit: Number,
            search: Boolean,
            searchFields: Array,
            searchPlaceHolder: String,
            searchQuery: String,
            noItemsText: String,
            allTotal: Number,
            sectionLimit: Number,
            onChangeSection: Function,
            onItemClick: Function,
        },
        methods: {
            getFieldValue: function(object, field) {
                let self = this;
                let fieldProp = field.prop.split('.');

                let val;
                switch (fieldProp.length) {
                    case 1:
                        val = object[fieldProp[0]];
                        break;
                    case 2:
                        val = object[fieldProp[0]][fieldProp[1]];
                        break;
                    case 3:
                        val = object[fieldProp[0]][fieldProp[1]][fieldProp[2]];
                        break;
                    case 4:
                        val = object[fieldProp[0]][fieldProp[1]][fieldProp[2]][fieldProp[3]];
                        break;
                }

                if (field.value)
                    return field.value(val, object);
                else
                    return val;
            },
            itemClick: function (item, action) {
                let self = this;

                this.$emit('onItemClick', self.items.indexOf(item), item, action.name);
            }



            /*
            onChange: function () {
                this.onChangeSection(this.section);

                let section = this.section.split(' - ');
                let st = parseInt(section[0]);
                let en = parseInt(section[1]);
                st = Math.ceil((st - 1) / this.limit) + 1;

                this.page = st;
            },
            renderItem: function (index, item) {
                return '<li><a href="#" class="item-link"><div class="item-content"><div class="item-inner">' + item.fname + '</div></div></a></li>';
            },
            rowNumber: function (item) {
                return (this.page - 1) * this.limit + (this.visibleItems.indexOf(item) + 1);
            },
            renderCell: function (item, column) {
                let rownumber = this.rowNumber(item);
                if (column['name'] === 'row') {
                    return rownumber;
                }

                //console.log(column['name']);
                if (column['renderTd']) {
                    return column['renderTd'](item);
                }

                return item[column['name']];
            },
            onAction: function (action, item) {
                action(item);
            },
            changePage: function (page) {
                this.page = page;
            },
            order: function (listOrdering) {
                if (this.listDirection === 'asc' && listOrdering === this.listOrdering)
                    this.listDirection = 'desc';
                else
                    this.listDirection = 'asc';

                this.listOrdering = listOrdering;

                this.reLoad();
            },
            reLoad: function () {

                let self = this;
                let ret;

                // Filter on search
                if (this.search && this.items.length > 0) {
                    ret = this.items.filter(function (el) {
                        for (let i = 0; i < self.searchFields.length; i++) {
                            if (el[self.searchFields[i]] !== undefined) {
                                if (el[self.searchFields[i]] && el[self.searchFields[i]].toLowerCase().indexOf(self.q.toLowerCase()) > -1)
                                    return el;
                            }
                            else
                                return el;
                        }
                    });
                }
                else
                    ret = this.items;

                //console.log(this.items);
                //console.log(self.searchFields);

                // First sort
                ret.sort(function compare(a, b) {
                    if (self.listOrdering === 'id') {
                        if (parseInt(a[self.listOrdering]) < parseInt(b[self.listOrdering]))
                            return self.listDirection === 'asc' ? -1 : 1;
                        if (parseInt(a[self.listOrdering]) > parseInt(b[self.listOrdering]))
                            return self.listDirection === 'asc' ? 1 : -1;
                    }
                    else {
                        if (a[self.listOrdering].toLowerCase() < b[self.listOrdering].toLowerCase())
                            return self.listDirection === 'asc' ? -1 : 1;
                        if (a[self.listOrdering].toLowerCase() > b[self.listOrdering].toLowerCase())
                            return self.listDirection === 'asc' ? 1 : -1;
                    }

                    return 0;
                });

                //console.log('ok');

                let end = this.page * this.limit;
                let start = end - this.limit;
                this.visibleItems = ret.slice(start, end);

                let section;
                let st, en;
                if (this.section) {
                    section = this.section.split(' - ');
                    st = parseInt(section[0]);
                    en = parseInt(section[1]);
                }
                else {
                    this.section = this.sections[0];
                    st = 1;
                    en = this.sectionLimit;
                }

                st = Math.ceil((st - 1) / this.limit) + 1;
                let total = ret.length;

                this.total = ret.length;
                this.pages = [];
                for (let i = st; i <= Math.ceil(total / this.limit); i++) {
                    this.pages.push(i);
                }

                if (this.q.length > 0)
                    this.filterTotal = ret.length;
                else
                    this.filterTotal = this.allTotal;
            },
            logItem: function (item) {
                console.log(item);
            }*/
        },
        created: function () {
            this.page = this.$route.query['page'] || 1;
            this.q = this.searchQuery;

            //window.t = this;
        }
    }
</script>


// WEBPACK FOOTER //
// VTable.vue?10f7313a